import { FormControl, FormGroup } from '@angular/forms';
import { ShareUserViewModel, UserSelectValue } from '@dntlab/share-files-dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import AppSettings from 'src/app/common/app.settings';
import { SendMessageFormService } from 'src/app/forms/conversation-forms/send-message-form.service';
import { SendMessageDialogResult } from 'src/app/interfaces';
import { FormGroupControls } from 'src/app/interfaces/form-and-field.interface';
import { UserBasic } from 'src/app/swagger-api';

export interface SearchField {
  shareInput: UserSelectValue[];
}

export interface DialogStrategy {
  users: ShareUserViewModel[];
  form: FormGroupControls<SearchField>;
  submitSuccessfully(message: string, selectedUsers: UserSelectValue[]): boolean;
}

export class NotSelectedUsers implements DialogStrategy {
  public users: ShareUserViewModel[] = [];

  public form: FormGroupControls<SearchField> = new FormGroup({
    shareInput: new FormControl<UserSelectValue[]>([], { nonNullable: true, validators: [] }),
  });

  public constructor(
    private activeModal: NgbActiveModal,
    private sendMessageFormService: SendMessageFormService,
  ) {}

  public submitSuccessfully(message: string, selectedUsers: UserSelectValue[]): boolean {
    const valid: boolean = selectedUsers.length > 0;

    if (valid) {
      this.activeModal.close({ message, participants: selectedUsers });
      this.sendMessageFormService.resetFormStatus();
    }

    return valid;
  }
}

export class SelectedUsers implements DialogStrategy {
  public users: ShareUserViewModel[] = [];

  public form: FormGroupControls<SearchField> = new FormGroup({
    shareInput: new FormControl<UserSelectValue[]>([], { nonNullable: true, validators: [] }),
  });

  public constructor(
    private activeModal: NgbActiveModal,
    private selectedUseres: UserBasic[],
    private sendMessageFormService: SendMessageFormService,
  ) {
    {
      this.users = this.selectedUseres.map((user: UserBasic) => {
        return {
          id: user.user_id,
          displayName: user.displayed_name,
          userStatus: user.account_status,
          imageUrl: user.image_url ?? AppSettings.NO_PHOTO_DEFAULT_IMAGE,
          email: '',
        };
      });
    }
  }

  public submitSuccessfully(message: string): boolean {
    const data: SendMessageDialogResult = {
      message,
      participants: this.selectedUseres.map((user: UserBasic) => ({
        id: user.user_id,
        itemName: '',
      })),
    };

    this.activeModal.close(data);
    this.sendMessageFormService.resetFormStatus();

    return true;
  }
}
